import { createActions } from "redux-actions";
import { Dispatch } from "redux";
import { BlogService } from "../../../services";

export const AllLabelsAcionTypes = createActions({
    loadAllLabelsStart: (data) => data,
    loadAllLabelsSuccess: (data) => data,
});

const getAllLabels = () => (
    dispatch: Dispatch
  ) => {
    dispatch(
        AllLabelsAcionTypes.loadAllLabelsStart({
        loading: true,
        data: [],
      })
    );
  
    BlogService.getAllLabels()
      .then((res) => {
        dispatch(
            AllLabelsAcionTypes.loadAllLabelsSuccess({
            loading: false,
            data: res.data.data,
          })
        );
      })
      .catch((err) => {});
  };

export const AllLabelsActions = {
    getAllLabels,
};
